<template>
  <statistics-card-line
    hideChart
    :icon="icon"
    icon-right
    :color="color"
    :statistic="count"
    :statisticTitle="title"
    :make-count-clickable="makeCountClickable"
    :tooltip-text="tooltipText"
    :tooltip-position="tooltipPosition"
    @count-clicked="$emit('count-clicked')">
    <template
      v-if="$slots.footer"
      v-slot:footer>
      <slot name="footer"></slot>
    </template>
  </statistics-card-line>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import enums from '@/enums';

/**
 * GS statistics card count
 *
 * @module views/charts-and-maps/charts/GsStatisticsCardCount
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-prop {Function} fetchDataFunction - function to fetch data
 * @vue-prop {string} icon - icon to show
 * @vue-prop {string} title - title to show
 * @vue-prop {string} color - color of icon
 * @vue-prop {boolean} makeCountClickable - whether to make the count clickable
 * @vue-prop {string} tooltipText - tooltip text for the count
 * @vue-prop {string} tooltipPosition - tooltip position for the count
 * @vue-data {number} count - count
 * @vue-event {void} getCount - fetch count
 * @vue-event {void} count-clicked - emitted when count is clicked
 */
export default {
  name: 'GsStatisticsCardCount',
  components: {
    StatisticsCardLine,
  },
  props: {
    fetchDataFunction: {
      type: Function,
      required: true,
    },
    fetchFilters: {
      required: false,
    },
    fetchFiltersMatch: {
      type: String,
      required: false,
      default: enums.AppFilter.FilterMathType.ALL,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    makeCountClickable: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltipText: {
      type: String,
      required: false,
      default: null,
    },
    tooltipPosition: {
      type: String,
      required: false,
      default: 'bottom',
    },
  },
  data() {
    return {
      count: 0,
    };
  },
  created() {
    this.getCount();
  },
  methods: {
    async getCount() {
      if (this.fetchFilters) {
        this.count = await this.fetchDataFunction({
          filters: this.fetchFilters,
          filtersMatch: this.fetchFiltersMatch,
        }) || 0;
      } else {
        this.count = await this.fetchDataFunction() || 0;
      }

      this.$emit('count', this.count);
    },
  },
};
</script>
